import { create } from '@bufbuild/protobuf';

import { wsAppRequestManager } from '../WsAppApi';
import {
  CheckAuthorizationRequest,
  CheckAuthorizationRequestSchema,
  CreateCalendarEventRequest,
  CreateCalendarEventRequestSchema,
  DeleteCalendarEventRequest,
  DeleteCalendarEventRequestSchema,
  DeleteRecurrenceEventRequest,
  DeleteRecurrenceEventRequestSchema,
  GetCalendarEventsRequest,
  GetCalendarEventsRequestSchema,
  LogoutCalendarRequest,
  LogoutCalendarRequestSchema,
  SearchUsersAddToCalendarEventRequest,
  SearchUsersAddToCalendarEventRequestSchema,
  SubscribeToCalendarPushRequest,
  SubscribeToCalendarPushRequestSchema,
  UpdateCalendarEventRequest,
  UpdateCalendarEventRequestSchema,
  UpdateEventParticipantStatusRequest,
  UpdateEventParticipantStatusRequestSchema,
  UpdateRecurrenceCalendarEventRequest,
  UpdateRecurrenceCalendarEventRequestSchema,
  GetUserSettingsRequest,
  GetUserSettingsRequestSchema,
  ChangeCompactRequest,
  ChangeCompactRequestSchema,
  UnsubscribeToCalendarPushRequest,
  UnsubscribeToCalendarPushRequestSchema,
  GetCalendarAuthUrlRequest,
  GetCalendarAuthUrlRequestSchema,
} from '../types/calendar/event_request_pb';
import {
  CheckAuthorizationResponse,
  CreateCalendarEventResponse,
  DeleteCalendarEventResponse,
  DeleteRecurrenceCalendarEventResponse,
  GetCalendarEventsResponse,
  LogoutCalendarResponse,
  SearchUsersAddToCalendarEventResponse,
  SubscribeToCalendarPushResponse,
  UpdateCalendarEventResponse,
  UpdateEventParticipantStatusResponse,
  UpdateRecurrenceCalendarEventResponse,
  GetUserSettingsResponse,
  ChangeCompactResponse,
  UnsubscribeToCalendarPushResponse,
  GetCalendarAuthUrlResponse,
} from '../types/calendar/event_response_pb';
import { WsRequest } from './request.types';

export function getCalendarEventsRequest(
  data: WsRequest<GetCalendarEventsRequest>
): Promise<GetCalendarEventsResponse> {
  return wsAppRequestManager.request<GetCalendarEventsResponse>({
    case: 'getCalendarEvents',
    value: create(GetCalendarEventsRequestSchema, data),
  });
}

export function deleteCalendarEventRequest(
  data: WsRequest<DeleteCalendarEventRequest>
): Promise<DeleteCalendarEventResponse> {
  return wsAppRequestManager.request<DeleteCalendarEventResponse>({
    case: 'deleteCalendarEvent',
    value: create(DeleteCalendarEventRequestSchema, data),
  });
}

export function deleteRecurrenceEventRequest(
  data: WsRequest<DeleteRecurrenceEventRequest>
): Promise<DeleteRecurrenceCalendarEventResponse> {
  return wsAppRequestManager.request<DeleteRecurrenceCalendarEventResponse>({
    case: 'deleteRecurrenceEvent',
    value: create(DeleteRecurrenceEventRequestSchema, data),
  });
}

export function createCalendarEventRequest(
  data: WsRequest<CreateCalendarEventRequest>
): Promise<CreateCalendarEventResponse> {
  return wsAppRequestManager.request<CreateCalendarEventResponse>({
    case: 'createCalendarEvent',
    value: create(CreateCalendarEventRequestSchema, data),
  });
}

export function updateCalendarEventRequest(
  data: WsRequest<UpdateCalendarEventRequest>
): Promise<UpdateCalendarEventResponse> {
  return wsAppRequestManager.request<UpdateCalendarEventResponse>({
    case: 'updateCalendarEvent',
    value: create(UpdateCalendarEventRequestSchema, data),
  });
}

export function updateRecurrenceCalendarEventRequest(
  data: WsRequest<UpdateRecurrenceCalendarEventRequest>
): Promise<UpdateRecurrenceCalendarEventResponse> {
  return wsAppRequestManager.request<UpdateRecurrenceCalendarEventResponse>({
    case: 'updateRecurrenceEvent',
    value: create(UpdateRecurrenceCalendarEventRequestSchema, data),
  });
}

export function subscribeToCalendarPushRequest(
  data: WsRequest<SubscribeToCalendarPushRequest>
): Promise<SubscribeToCalendarPushResponse> {
  return wsAppRequestManager.request<SubscribeToCalendarPushResponse>(
    {
      case: 'subscribeToPush',
      value: create(SubscribeToCalendarPushRequestSchema, data),
    },
    true
  );
}

export function unsubscribeFromCalendarPushRequest(
  data: WsRequest<UnsubscribeToCalendarPushRequest>
): Promise<UnsubscribeToCalendarPushResponse> {
  return wsAppRequestManager.request<UnsubscribeToCalendarPushResponse>(
    {
      case: 'unsubscribeToPushRequest',
      value: create(UnsubscribeToCalendarPushRequestSchema, data),
    },
    true
  );
}

export function checkAuthorizationRequest(
  data: WsRequest<CheckAuthorizationRequest>
): Promise<CheckAuthorizationResponse> {
  return wsAppRequestManager.request<CheckAuthorizationResponse>({
    case: 'checkAuthorization',
    value: create(CheckAuthorizationRequestSchema, data),
  });
}

export function logoutCalendarRequest(
  data: WsRequest<LogoutCalendarRequest>
): Promise<LogoutCalendarResponse> {
  return wsAppRequestManager.request<LogoutCalendarResponse>({
    case: 'logout',
    value: create(LogoutCalendarRequestSchema, data),
  });
}

export function updateEventParticipantStatusRequest(
  data: WsRequest<UpdateEventParticipantStatusRequest>
): Promise<UpdateEventParticipantStatusResponse> {
  return wsAppRequestManager.request<UpdateEventParticipantStatusResponse>({
    case: 'updateEventParticipantStatus',
    value: create(UpdateEventParticipantStatusRequestSchema, data),
  });
}

export function searchUsersAddToCalendarEventRequest(
  data: WsRequest<SearchUsersAddToCalendarEventRequest>
): Promise<SearchUsersAddToCalendarEventResponse> {
  return wsAppRequestManager.request<SearchUsersAddToCalendarEventResponse>({
    case: 'searchUsersAddToCalendarEvent',
    value: create(SearchUsersAddToCalendarEventRequestSchema, data),
  });
}

export function getUserSettingsCalendarRequest(
  data: WsRequest<GetUserSettingsRequest>
): Promise<GetUserSettingsResponse> {
  return wsAppRequestManager.request<GetUserSettingsResponse>({
    case: 'getUserSettings',
    value: create(GetUserSettingsRequestSchema, data),
  });
}

export function changeCompactCalendarViewRequest(
  data: WsRequest<ChangeCompactRequest>
): Promise<ChangeCompactResponse> {
  return wsAppRequestManager.request<ChangeCompactResponse>({
    case: 'changeCompact',
    value: create(ChangeCompactRequestSchema, data),
  });
}

export function getCalendarAuthUrlRequest(
  data: WsRequest<GetCalendarAuthUrlRequest>
): Promise<GetCalendarAuthUrlResponse> {
  return wsAppRequestManager.request<GetCalendarAuthUrlResponse>({
    case: 'getCalendarUrl',
    value: create(GetCalendarAuthUrlRequestSchema, data),
  });
}
